import { Injectable } from '@angular/core';

const STORAGE_KEY = 'telmah_dark_mode';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private _isDark = false;

  get isDark(): boolean {
    return this._isDark;
  }

  constructor() {
    this._isDark = localStorage.getItem(STORAGE_KEY) === '1';
  }

  toggle(): void {
    this._isDark = !this._isDark;
    localStorage.setItem(STORAGE_KEY, this._isDark ? '1' : '0');
  }
}
